module.exports = __webpack_public_path__ + "static/media/electrostatic-check-w.df07ed3b.png";